import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthToken } from '@app/core/state/app.state';
import { User } from './auth.model';

export interface LoginRequest {
  email: string;
  password: string;
}

export const AuthActions = createActionGroup({
  source: 'Auth/API',
  events: {
    'Hydrate Auth': emptyProps(),
    'Hydrate Auth Success': props<{ user: User; token: AuthToken }>(),
    'Login': props<{ credentials: LoginRequest }>(),
    'Login Success': props<{ user: User; token: AuthToken }>(),
    'Login Failure': props<{ error: string }>(),
    'Logout': emptyProps(),
    'Clear Error': emptyProps(),
  },
});
